import React from 'react'
import { social } from '../data'

const Contact = () => {
  return (
    <section
      id='contact'
      className='bg-primary text-white section py-24'
    >
      <div className='container mx-auto text-center'>
        <h2 className='text-5xl font-primary font-extrabold mb-6'>
          Contact Us
        </h2>

        <p className='max-w-[720px] mx-auto px-6 lg:px-0 mb-12 leading-relaxed'>
          <strong>S. Bhasin & Associates</strong> is a law firm based in Dwarka, New Delhi,
          providing legal services across a wide range of practice areas. The firm
          regularly handles matters before all District Courts of Delhi, the High Court
          of Delhi, and the Supreme Court of India. With a client-focused approach, the
          firm represents individuals and businesses in litigation, advisory, and
          dispute resolution matters. S. Bhasin & Associates is committed to delivering
          practical legal solutions with professionalism, integrity, and diligence.
        </p>

        {/* Contact Details */}
        <div className='max-w-[720px] mx-auto text-left  rounded-sm p-6 mb-12'>
          <p className='mb-3'>
            <span className='font-semibold'>Addresses:</span><br />
            C-711, Ramphal Chowk Rd, near Shiksha bharti college, Sector 7 Dwarka,<br />
            Palam, New delhi, Delhi - 110085, India
          </p>
          <p className='mb-3'>
            Chamber No. T-6, Tehsil Lane,<br />
            Tis Hazari Court Complex, New delhi, Delhi - 110054, India
          </p>
          <p className='mb-2'>
            <span className='font-semibold'>Phone:</span>{' '}
            <a
              href='tel:+919899331166'
              className='underline hover:text-accent transition'
            >
              +91-9899331166
            </a>, &nbsp;
            <a
              href='tel:+919868735570'
              className='underline hover:text-accent transition'
            >
              +91-9868735570
            </a>
          </p>

          <p>
            <span className='font-semibold'>Email:</span>{' '}
            <a
              href='mailto:sbhasinassociates@gmail.com'
              className='underline hover:text-accent transition'
            >
              sbhasinassociates@gmail.com
            </a>
          </p>
        </div>

        {/* socials */}
        <div className='flex items-center justify-center gap-6'>
          {social.map((item, index) => {
            const { icon, link } = item
            return (
              <a
                key={index}
                href={link}
                target='_blank'
                rel='noopener noreferrer'
                className='hover:opacity-80 transition'
              >
                <img src={icon} alt='social link' />
              </a>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default Contact
